module.exports = __webpack_public_path__ + "static/media/school_icon.7a6de3dd.png";